import React from 'react';
import "../css/loader.css";

const Commonloader = ({ text = "Loading Data..." }) => {
  return (
    <div className="loader-overlay">
      <div className="modern-loader-wrapper">

        <div className="modern-loader">
          <span></span>
          <span></span>
          <span></span>
        </div>

        <h3>{text}</h3>
        <p>Please wait while we fetch your details...</p>

      </div>
    </div>
  );
};

export default Commonloader;